import { Component, ViewEncapsulation, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'ft-menu-object',
  templateUrl: './menu-object.component.html',
  styleUrls: ['./menu-object.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule, FormsModule, MatCheckboxModule, MatSelectModule, MatOptionModule]
})
export class MenuObjectDialogComponent {

  dialogRef = inject<MatDialogRef<MenuObjectDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA) ?? {};

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (this.data.errorFunc) {
      this.data.errorFunc();
    }

    this.dialogRef.close();
  }

  discard() {
    if (this.data.discardFunc) {
      this.data.discardFunc();
    }

    this.dialogRef.close();
  }

  ok() {
    if (this.data.succFunc) {
      this.data.succFunc();
    }

    this.dialogRef.close();
  }
}
